import styled from 'styled-components';
import { FieldWrapper } from 'components';
import { theme, toRem } from 'design';

// Add User Form
export const Form = styled.form`
  width: 100%;
  padding-top: ${toRem(theme.space.md)};
`;

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.xl)};
  width: 100%;

  @media (min-width: ${theme.breakpoint.med}px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${toRem(theme.space['2xl'])} ${toRem(theme.space.xl)};
  }

  @media (min-width: ${theme.breakpoint.large}px) {
    grid-template-columns: repeat(auto-fit, minmax(${toRem(250)}, 1fr));
  }

  @media (min-width: ${theme.breakpoint.xlarge}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StyledFieldWrapper = styled(FieldWrapper)`
  margin-bottom: 0;
`;

export const Footer = styled.footer`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  width: 100%;
  margin: ${toRem(theme.space['3xl'])} 0;
  padding-top: ${toRem(theme.space['2xl'])};
  border-top: ${toRem(1)} solid ${theme.color.neutral[200]};
`;
